import React, { useEffect } from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const AttendanceListContent = ({data}) => {

    useEffect(() => {
        const labels = [
            "ID",
            "Protocolo",
            "Status",
            "Data início",
            "Dia da semana",
            "Criador atendimento",
            "Canal atendimento",
            "Origem atendimento",
            "Anonimato",
            "Telefone",
            "Logradouro",
            "Bairro",
            "Setor",
            "Natureza",
            "Grupo da natureza"
        ];

        const values = data.attendanceList.map(item => [
            item.attendance_id,
            item.attendance_protocol,
            item.attendance_statusname,
            item.dt_start,
            item.dow,
            item.attendance_creator,
            item.channel,
            item.source,
            item.anonymous,
            item.phone,
            item.street,
            item.neighborhood,
            item.sectors,
            item.nature,
            item.nature_group
        ]);

        ReportUtils.createExportableTable(labels, values, "Informações gerais");

    }, [data]);

    return null;
};

export default AttendanceListContent;